// ─── Astria GCC v2 — response cache reset. useGCCV2TabResult.ts caches each

const GCC_V2_TAB_KEYS = [
  "timing",
  "kyusei",
  "companion",
  "emotional",
  "personality",
] as const;

export const clearAstriaGCCV2ResponseCache = (): void => {
  try {
    for (const tabKey of GCC_V2_TAB_KEYS) {
      for (const language of ["en", "ar"]) {
        sessionStorage.removeItem(`astriaGCCV2_${tabKey}_${language}`);
      }
    }
  } catch {
    // ignore storage failures
  }
};
